import React from "react";
import Loadable from "react-loadable"; // This is tweaked fork of the official react-loadable module, with some tweaks to work with Webpack 4.

import { Loading } from "./Loading";

const LoadableComponent = Loadable({
    loader: () => import(/* webpackChunkName: "react_calendar_EventAddOrEditContainer" */ "./EventAddOrEditContainer"), // Loading chunk 5 failed.
    loading: Loading,
});

const LoadableEventAddOrEditContainer: React.SFC<{}> = () => {
    return (
        <LoadableComponent />
    );
};

export default LoadableEventAddOrEditContainer;
